$('#form-raffle-tickets').on('submit', function (e) {
    e.preventDefault();

    var theForm = $(this),
        submitBtn = theForm.find('input[type="submit"]'),
        waitBtn = $('#raffle-wait-btn'),
        purchaseHeader = 'Purchase Summary\n\n',
        purchaseFieldText = '',
        purchaseField = $('#input_16_33');

    // Disable submit button and show wait
    submitBtn.prop('disabled', true).hide();
    waitBtn.show();

    var ticketFieldHasQuantity = 0;

    // If any raffle ticket quantities are greater than 1, add to GF input
    $('.raffle-item-quantity').each(function () {
        var itemName = $(this).parent().find('.raffle-item-name').text();

        if ( $(this).val() > 0 ) {

            ticketFieldHasQuantity++;

            if ( purchaseFieldText == '' ) {
                purchaseFieldText = purchaseHeader;
            }
            purchaseFieldText = purchaseFieldText + itemName + ': ' + $(this).val() + ' tickets\n';
        }
    });

    // User is purchasing at least one ticket
    if ( ticketFieldHasQuantity > 0 ) {
        // Update hidden field text
        purchaseField.html(purchaseFieldText);

        PW.submitRaffleTicketForm(); // /js/pw-submit-raffle-form.js
    } else {
        $('#raffle-form-validation-error-placeholder').show().find('.validation_error').html('You haven\'t selected any tickets for purchase.');
        // Scroll to top
        $('html, body').animate({ scrollTop: 0 }, '800');

        // Enable submit button and hide wait
        submitBtn.show().prop('disabled', false);
        waitBtn.hide();
    }
});

$('.raffle-item-quantity').on('input change', function () {
    $('#raffle-form-validation-error-placeholder').fadeOut().find('.validation_error').html('');
});